import { ChangeEvent, Dispatch } from 'react';
import styled from 'styled-components';

import TextareaMobile from '@/components/atom/form/TextareaMobile';

export interface QnaWriteContentTextareaProps {
  question: string;
  onChangeQuestion: Dispatch<string>;
  placeholder?: string;
}

const QnaWriteContentTextarea = ({ question, onChangeQuestion, placeholder }: QnaWriteContentTextareaProps) => {
  const onChangeTextarea = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChangeQuestion(event.target.value.replace(/^\s+/g, ''));
  };

  return (
    <QnaContentWrapper>
      <QnaWriteTextarea
        id='quickAnswerQuestion'
        label='질문'
        height='150px'
        placeholder={placeholder ?? '예) 약을 처방 받았는데 술을 마셔도 될까요?'}
        maxLength={500}
        value={question}
        onChange={onChangeTextarea}
        showCharacterCount={true}
      />
    </QnaContentWrapper>
  );
};

export default QnaWriteContentTextarea;

const QnaContentWrapper = styled.div`
  margin-bottom: 40px;
`;

const QnaWriteTextarea = styled(TextareaMobile)`
  margin-bottom: 12px;
`;
